var _path, _mask, _path2, _mask2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M55 34.5C55 38.5545 53.6511 44.518 51.1238 47.8892C48.5965 51.2604 45.0044 53.8879 40.8017 55.4395C36.599 56.9911 31.9745 57.3971 27.5129 56.6061C23.0514 55.8151 18.9532 53.8627 15.7365 50.9957C12.5199 48.1287 10.3294 44.476 9.44194 40.4994C8.55448 36.5227 9.00996 32.4009 10.7508 28.655C12.4916 24.9091 15.4396 21.7074 19.2219 19.4549C23.0042 17.2023 27.451 16 32 16V34.5H55Z",
    fill: "#F93749"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_527_820",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57 33.5C57 38.3456 55.5631 43.0825 52.871 47.1115C50.1789 51.1405 46.3525 54.2807 41.8757 56.135C37.399 57.9894 32.4728 58.4746 27.7203 57.5292C22.9678 56.5839 18.6023 54.2505 15.1759 50.8241C11.7495 47.3977 9.4161 43.0322 8.47076 38.2797C7.52542 33.5272 8.0106 28.601 9.86495 24.1243C11.7193 19.6475 14.8595 15.8211 18.8885 13.129C22.9175 10.4369 27.6544 9 32.5 9V33.5H57Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57 33.5C57 38.3456 55.5631 43.0825 52.871 47.1115C50.1789 51.1405 46.3525 54.2807 41.8757 56.135C37.399 57.9894 32.4728 58.4746 27.7203 57.5292C22.9678 56.5839 18.6023 54.2505 15.1759 50.8241C11.7495 47.3977 9.4161 43.0322 8.47076 38.2797C7.52542 33.5272 8.0106 28.601 9.86495 24.1243C11.7193 19.6475 14.8595 15.8211 18.8885 13.129C22.9175 10.4369 27.6544 9 32.5 9V33.5H57Z",
    stroke: "#F93749",
    strokeWidth: 3,
    mask: "url(#path-2-inside-1_527_820)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_527_820",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5 6C39.7174 6 42.9033 6.63371 45.8757 7.86495C48.8482 9.09619 51.5491 10.9008 53.8241 13.1759C56.0992 15.4509 57.9038 18.1518 59.135 21.1243C60.3663 24.0967 61 27.2826 61 30.5L36.5 30.5V6Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 6C39.7174 6 42.9033 6.63371 45.8757 7.86495C48.8482 9.09619 51.5491 10.9008 53.8241 13.1759C56.0992 15.4509 57.9038 18.1518 59.135 21.1243C60.3663 24.0967 61 27.2826 61 30.5L36.5 30.5V6Z",
    stroke: "#F93749",
    strokeWidth: 3,
    mask: "url(#path-3-inside-2_527_820)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/Analytics.31d1fcde1c6cb5eb17876d07a53ec88e.svg";
export { ForwardRef as ReactComponent };